import { call, put, takeLatest , select } from 'redux-saga/effects';
import ApiRouts from '../../api/routes';
import {GET} from "../../api";
import {
    FETCH_BANNER,
    SET_BANNER,
} from "../actions";
import {setLoading} from "../slices/loadingSlice";



const getSelectedId = (state) => state.selectItemDrawerMenu.selectedId;

export function* FetchBannerSaga() {

    const selectedId = yield select(getSelectedId);


    try {

        yield put(setLoading(true));

        const response = yield call(GET, `${ApiRouts.API_BANNER}${selectedId?`/${selectedId}`:''}` , {});

        if (response) {

            yield put({
                type:SET_BANNER,
                payload:response.data.data
            });
            yield put(setLoading(false)); // Set loading to false after fetching

        } else {
            throw new Error('Failed to fetch the latest version');
        }

    } catch (error) {
        // yield put(setError(error.message));  // Set error if something goes wrong
        yield put(setLoading(false));  // End loading in case of error
    } finally {
        yield put(setLoading(false)); // Set loading to false after fetching
    }
}

// Watcher Saga
function* bannerSaga() {
    yield takeLatest(FETCH_BANNER, FetchBannerSaga);
    // yield takeLatest(SET_LATEST_VERSION, setLatestVersion);
}

export default bannerSaga;
